import HttpClient from '../../services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseURL } from '../../services/getBaseURL';
// import { metrix } from '../../services/metrixConfigure';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
// const _metrix = metrix();
const baseUrl = getBaseURL().wallet;
const baseURLDefault = getBaseURL().base;

const initialState = {
	infoStep: 1,
	walletStep: null,
	walletRequestID: null,
	statusError: '',
	cashPayFee: '',
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	walletState: [],
	getWallets: [],
	message: '',
	Sponsors: [],
	valueAmount: null,
	personalInfo: {
		gender: '',
		fullName: '',
		birthDate: '',
		city: '',
		state: '',
		sabteAhval: null,
		mainService: null,
		IdentityStatus: null,
	},
	credit: {
		amount: 6000000,
		maxAmount: 20000000,
		minAmount: 2000000,
		amountStep: 500000,
		plan: 'bank_mehr',
	},
	walletCreditInfo: {
		amount: 0,
		operationCost: 0,
		installmentCount: 5,
		installmentPay: 0,
		finalPay: 0,
		karmozd: 0,
	},
	WalletRequestLimMax: null,
	tracking_code: '',
	bankVerify: {
		CBIStatus: '',
		Flag: '',
	},
	validationState: false,
	walletAmountLimit: {},
	loanAmount: '',
	currentWallet: null,
	agreementContent: '',
	walletDocumentCompleted: null,
	walletCalculator: {},
};

// getWallet
export const GetWalletRequest = createAsyncThunk('home/wallet', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};

	const param = {};
	const response = await http

		.post(`${baseURLDefault}/GetWallets`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const GetWallets = createAsyncThunk('home/', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {};
	const response = await http.post(`${baseUrl}/Wallets`, param, { headers: headers }).then((res) => res.data);
	return response;
});

export const walletSponsorList = createAsyncThunk(
	'walletrequest/walletSponsorList',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);
		const { WalletRequestTypeID } = params;
		const headers = {
			'Authorization': token,
		};
		const param = { WalletRequestTypeID: WalletRequestTypeID };
		const response = await http
			.post(`${baseUrl}/walletSponsorList`, param, { headers: headers })
			.then((res) => res.data);
		return response;
	},
);

export const GetLimits = createAsyncThunk('walletrequest/GetLimits', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		WalletRequestTypeID: params?.WalletRequestTypeID,

		// WalletSponsorConditionID: 111111118,
	};
	const response = await http
		.post(`${baseUrl}/WalletRequest`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const WalletConfirm = createAsyncThunk('Wallet/WalletConfirm', async (params, thunkAPI) => {
	const { isToastfy, ...rest } = params;
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const response = await http
		.post(`${baseUrl}/WalletConfirm`, rest, { headers: headers }, isToastfy)
		.then((res) => res.data);
	return response;
});

export const personalData = createAsyncThunk('walletrequest/personalData', async (params, thunkAPI) => {
	const { day, month, year, walletRequestID, isToastfy } = params;
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		WalletRequestID: walletRequestID,
		BirthYear: year,
		BirthMonth: month,
		BirthDay: day,
		PostalCode: '',
	};
	const response = await http
		.post(`${baseUrl}/PersonalData`, param, { headers: headers }, isToastfy)
		.then((res) => {
			return res.data;
		});
	return response;
});

export const provinceData = createAsyncThunk('walletrequest/provinceData', async (params, thunkAPI) => {
	const { ProvinceID, CityID, WalletRequestID } = params;
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		WalletRequestID: WalletRequestID,
		ProvinceID: ProvinceID,
		CityID: CityID,
	};
	const response = await http
		.post(`${baseUrl}/PersonalDataProvinceCity`, param, { headers: headers })
		.then((res) => {
			const stateValues = thunkAPI.getState()?.walletRequestOne;
			const attribute = {
				'Wallet Type': String(stateValues?.currentWallet?.WalletRequestTypeID || ''),
				'Wallet ID': String(WalletRequestID || ''),
				'City': String(params?.cityName || ''),
				'Province': String(params?.provinceName || ''),
			};

			// // dmarp === WR - Province and City
			// _metrix.sendEvent('dmarp', attribute);

			return res.data;
		});
	return response;
});

export const CBIVerification = createAsyncThunk('wallet/CBIVerification', async (params) => {
	const { token, isToastfy } = params;

	const headers = {
		'Authorization': `Bearer ${token}`,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/CBIVerification`, param, { headers: headers }, isToastfy)
		.then((res) => res.data);
	return response;
});

export const terms = createAsyncThunk('walletrequest/terms', async (params, thunkAPI) => {
	const { valueAmount, walletRequestID, isToastfy, InstallmentCount } = params;
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		LoanAmount: valueAmount * 10,
		walletRequestID: walletRequestID,
		InstallmentCount: InstallmentCount,
	};
	const response = await http
		.post(`${baseUrl}/WalletRequestTerms`, param, { headers: headers }, isToastfy)
		.then((res) => {
			const stateValues = thunkAPI.getState()?.walletRequestOne;

			if (res?.data?.Success) {
				// // ufbnc === WR - Credit and Installments
				// _metrix.sendEvent('ufbnc', {
				// 	'LoanAmount': String(valueAmount * 10),
				// 	'Wallet Type': String(stateValues?.currentWallet?.WalletRequestTypeID || ''),
				// 	'Wallet ID': String(walletRequestID || ''),
				// 	'Currency': 'IRR',
				// 	'Financier Fee': String(((valueAmount * 2) / 100) * 10),
				// 	'Installment Count': String(stateValues?.walletCreditInfo?.installmentCount),
				// });
			}

			return res.data;
		});
	return response;
});

export const walletRequestsStatus = createAsyncThunk('walletrequest/status', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const response = await http
		.post(`${baseUrl}/WalletRequestsStatus`, params, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const walletAgreement = createAsyncThunk('walletrequest/walletAgreement', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http.post(`${baseUrl}/AgreementConfirm`, param, { headers: headers }).then((res) => {
		const stateValues = thunkAPI.getState()?.walletRequestOne;
		// const attribute = {
		// 	'Wallet Type': String(stateValues?.currentWallet?.WalletRequestTypeID || ''),
		// 	'Wallet ID': String(params.walletRequestID || ''),
		// };

		// // zyovy === WR - Agreement
		// _metrix.sendEvent('zyovy', attribute);

		return res.data;
	});
	return response;
});

export const confirmBankAccount = createAsyncThunk(
	'walletrequest/confirmBankAccount',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);
		const headers = {
			'Authorization': token,
		};
		const param = {
			walletRequestID: params.walletRequestID,
		};
		const response = await http
			.post(`${baseUrl}/WalletBankNumberConfirm`, param, { headers: headers })
			.then((res) => {
				return res.data;
			});
		return response;
	},
);

export const OperatingCosts = createAsyncThunk('walletrequest/OperatingCosts', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/WalletRequestOperatingCosts`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const getAgreement = createAsyncThunk('walletrequest/agreement', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/Agreement`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

const walletRequestOne = createSlice({
	name: 'walletRequestOne',
	initialState,
	reducers: {
		setAmountCredit(state, action) {
			state.credit.amount = action.payload;
		},
		changeInfoStep(state, action) {
			state.infoStep = action.payload;
		},
		resetInfoStep(state) {
			state.infoStep = 1;
		},
		setSabteAhval(state, action) {
			state.personalInfo.sabteAhval = action.payload;
		},
		setValidationState(state, action) {
			state.validationState = action.payload;
		},

		setStatusError(state, action) {
			state.statusError = action.payload;
		},
		setSwichWallet(state, action) {
			state.currentWallet = action.payload;
		},

		SetValueAmount(state, action) {
			state.valueAmount = action.payload;
		},
		setWalletCreditInfoNewFlow(state, action) {
			state.walletCreditInfo = action.payload;
		},
		setInstamentCount(state, action) {
			state.walletCreditInfo.installmentCount = action.payload?.count || 5;
		},
		setProvinceAndCity(state, action) {
			state.personalInfo.city = action.payload.city;
			state.personalInfo.state = action.payload.state;
		},
		signOutWallet() {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(personalData.pending, (state) => {
				state.isLoading.button = true;
				state.personalInfo.sabteAhval = null;
			})
			.addCase(personalData.fulfilled, (state, action) => {
				const { Content, Success, Status } = action.payload;
				const { year, month, day } = action.meta.arg;
				if (Success && Status === 200) {
					if (Content.Identity.ServiceStatus) {
						state.personalInfo.mainService = true;
						if (Content.Identity.IdentityStatus) {
							state.personalInfo.sabteAhval = true;
							state.personalInfo.fullName = `${Content.Identity.Name} ${Content.Identity.LastName}`;
							state.personalInfo.birthDate = `${year}/${month}/${day}`;
							state.personalInfo.gender = Content.Identity.Gender;
						} else {
							state.personalInfo.sabteAhval = false;
						}
					} else {
						state.personalInfo.mainService = false;
					}
				} else if (Success && Status !== 200) {
					state.personalInfo.mainService = false;
				}
				state.personalInfo.IdentityStatus = Content?.Identity?.IdentityStatus;
				//else
				//    state.personalInfo.sabteAhval = false;
				state.isLoading.button = false;
			})
			.addCase(personalData.rejected, (state) => {
				state.isLoading.button = false;
			});
		builder
			.addCase(CBIVerification.pending, (state) => {
				state.isLoading.skeleton = true;
				state.status = 'pending';
			})
			.addCase(CBIVerification.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.bankVerify.CBIStatus = Content?.CBIStatus;
					state.bankVerify.Flag = Content?.Flag;
				} else {
					state.bankVerify.CBIStatus = false;
				}
				state.isLoading.skeleton = false;
			})
			.addCase(CBIVerification.rejected, (state) => {
				state.status = 'error';
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(GetWalletRequest.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetWalletRequest.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.walletState = Content.sponsors;
				} else {
					state.message = Message;
				}
			})
			.addCase(GetWalletRequest.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});
		builder
			.addCase(GetWallets.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(GetWallets.fulfilled, (state, action) => {
				state.isLoading.button = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.getWallets = Content.Wallets;
				} else {
					state.message = Message;
				}
			})
			.addCase(GetWallets.rejected, (state) => {
				state.isLoading.button = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});

		builder
			.addCase(walletSponsorList.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(walletSponsorList.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Content, Success, Message } = action.payload;
				if (Success) {
					state.Sponsors = Content.Sponsors;
				} else {
					state.message = Message;
				}
			})
			.addCase(walletSponsorList.rejected, (state) => {
				state.isLoading.button = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});
		builder
			.addCase(GetLimits.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetLimits.fulfilled, (state, action) => {
				const { Content, Success, Message } = action.payload;
				if (Success) {
					state.walletAmountLimit = Content.WalletRequestLimits;
					state.walletRequestID = Content.WalletRequestID;
				} else {
					state.message = Message;
				}
				state.isLoading.skeleton = false;
				// if (Success && Status === 200) {
				// 	state.walletAmountLimit = Content.WalletRequestLimits;
				// 	state.walletRequestID = Content.WalletRequestID;
				// } else if (Status === 462) {
				// 	state.statusError = 'cantReq';
				// } else if (Status === 601 || Status === 633) state.statusError = 'maxAmount';
			})
			.addCase(GetLimits.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});
		builder
			.addCase(walletRequestsStatus.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(walletRequestsStatus.fulfilled, (state, action) => {
				const { Success, Content, Status } = action.payload;
				if (Success && Status === 200) {
					state.walletCalculator = Content?.WalletRequest || {};
				}

				state.isLoading.skeleton = false;
			})
			.addCase(walletRequestsStatus.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
		builder
			.addCase(terms.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(terms.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(terms.rejected, (state) => {
				state.isLoading.button = false;
			});
		builder
			.addCase(OperatingCosts.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(OperatingCosts.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(OperatingCosts.rejected, (state) => {
				state.isLoading.button = false;
			});

		builder
			.addCase(getAgreement.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getAgreement.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) state.agreementContent = !!Content.Template ? Content.Template : ' ';
				state.isLoading.skeleton = false;
			})
			.addCase(getAgreement.rejected, (state) => {
				state.isLoading.skeleton = false;
			});

		builder
			.addCase(provinceData.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(provinceData.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(provinceData.rejected, (state) => {
				state.isLoading.button = false;
			});

		builder
			.addCase(confirmBankAccount.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(confirmBankAccount.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(confirmBankAccount.rejected, (state) => {
				state.isLoading.button = false;
			});
		builder
			.addCase(walletAgreement.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(walletAgreement.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(walletAgreement.rejected, (state) => {
				state.isLoading.button = false;
			});
		builder
			.addCase(WalletConfirm.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(WalletConfirm.fulfilled, (state) => {
				state.isLoading.button = false;
				state.walletStep = 1;
			})
			.addCase(WalletConfirm.rejected, (state) => {
				state.isLoading.button = false;
			});
	},
});

export const {
	setAmountCredit,
	setStatusError,
	changeInfoStep,
	setSabteAhval,
	setValidationState,
	SetValueAmount,
	setWalletCreditInfoNewFlow,
	setProvinceAndCity,
	signOutWallet,
	setInstamentCount,
	setSwichWallet,
	resetInfoStep,
} = walletRequestOne.actions;
export default walletRequestOne.reducer;
